import { Box } from '@mui/material';
import React from 'react';

export default function SettingsRow({ children, sx = {}, ...rest }) {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'row', gap: '15px', mb: 1, ...sx }}
      {...rest}
    >
      {children}
    </Box>
  );
}
